const services = [
  {
    img: "https://readdy.ai/api/search-image?query=Japanese%20uniformed%20removal%20workers%20carefully%20carrying%20cardboard%20boxes%20out%20of%20a%20traditional%20Kyoto%20home%20entrance%2C%20clean%20warm%20natural%20light%2C%20professional%20trustworthy%20atmosphere%2C%20neutral%20warm%20tones%2C%20editorial%20photography%20style%2C%20simple%20clean%20background%2C%20high%20detail&width=800&height=600&seq=ats-service-01&orientation=landscape",
    title: "不用品回収",
    href: "/fuyouhin-kaisyu",
    tag: "京都 不用品回収",
    text: "家具・家電・大型ゴミからお部屋まるごとまで、1点から丸ごとまで対応可能。軽トラ・2トン・4トンとご依頼量に応じた最適プランをご提案します。",
    items: ["家具・家電1点から", "引越しに伴う一括回収", "大型ゴミ・粗大ゴミ", "分別・搬出込み"],
  },
  {
    img: "https://readdy.ai/api/search-image?query=Respectful%20Japanese%20estate%20cleanup%20service%20workers%20gently%20sorting%20personal%20items%20on%20tatami%20mat%20in%20a%20quiet%20Kyoto%20room%2C%20soft%20natural%20window%20light%2C%20calm%20dignified%20atmosphere%2C%20warm%20muted%20tones%2C%20editorial%20photography%2C%20simple%20clean%20background&width=800&height=600&seq=ats-service-02&orientation=landscape",
    title: "遺品整理",
    href: "/ihin-seiri",
    tag: "京都 遺品整理",
    text: "ご遺族様に寄り添う遺品整理。貴重品・思い出の品の仕分け、供養品の合同供養、形見分けまで一貫サポートいたします。",
    items: ["貴重品・書類の仕分け", "合同供養サービス", "遠方のご遺族対応", "遺品整理士在籍"],
  },
  {
    img: "https://readdy.ai/api/search-image?query=Before%20and%20after%20professional%20deep%20cleaning%20of%20a%20cluttered%20Japanese%20apartment%20interior%2C%20clean%20restored%20room%20with%20natural%20light%2C%20warm%20neutral%20tones%2C%20clean%20sanitary%20atmosphere%2C%20editorial%20photography%2C%20simple%20clean%20background%2C%20high%20detail%20subtle%20composition&width=800&height=600&seq=ats-service-03&orientation=landscape",
    title: "ゴミ屋敷清掃",
    href: "/gomi-yashiki",
    tag: "京都 ゴミ屋敷清掃",
    text: "深刻に堆積したゴミも、経験豊富なスタッフが一気に片付け・除菌・消臭。プライバシー厳守で近隣にも配慮した作業を行います。",
    items: ["近隣配慮の梱包搬出", "消臭・除菌作業込み", "害虫駆除オプション", "秘密厳守"],
  },
  {
    img: "https://readdy.ai/api/search-image?query=Empty%20clean%20rental%20apartment%20room%20after%20professional%20abandoned%20items%20removal%20service%20in%20Japan%2C%20polished%20wooden%20floor%2C%20soft%20natural%20light%20through%20window%2C%20warm%20neutral%20tones%2C%20clean%20professional%20atmosphere%2C%20editorial%20photography%2C%20simple%20clean%20background&width=800&height=600&seq=ats-service-04&orientation=landscape",
    title: "残置物撤去",
    href: "",
    tag: "退去・空室化",
    text: "不動産会社様・オーナー様向け。入居者退去後の残置物一括撤去、原状回復前クリーニングまで、鍵預かり対応も可能です。",
    items: ["管理会社様継続対応", "鍵預かりOK", "月次請求書払い", "写真報告書提出"],
  },
  {
    img: "https://readdy.ai/api/search-image?query=Industrial%20waste%20recycling%20facility%20with%20neatly%20sorted%20materials%20and%20clean%20truck%20in%20Kyoto%2C%20professional%20workers%20in%20uniform%2C%20warm%20natural%20daylight%2C%20clean%20organized%20atmosphere%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20simple%20clean%20background&width=800&height=600&seq=ats-service-05&orientation=landscape",
    title: "産廃回収",
    href: "",
    tag: "法人対応",
    text: "京都府認可の産廃許可に基づき、事業ゴミ・建設廃材・什器などの回収から適正処分まで一貫対応。マニフェスト発行可能。",
    items: ["マニフェスト対応", "定期回収契約OK", "什器・OA機器処分", "解体現場の廃材"],
  },
  {
    img: "https://readdy.ai/api/search-image?query=Professional%20office%20relocation%20service%20with%20workers%20moving%20office%20chairs%20and%20desks%20in%20a%20clean%20Japanese%20office%20building%2C%20warm%20natural%20daylight%2C%20clean%20professional%20atmosphere%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20simple%20clean%20background&width=800&height=600&seq=ats-service-06&orientation=landscape",
    title: "オフィス移転・原状回復",
    href: "",
    tag: "法人対応",
    text: "オフィス什器の一括処分から原状回復工事のご相談まで。京都市内はもちろん、京都府下の企業様案件も柔軟に承ります。",
    items: ["什器一括処分", "原状回復ご相談", "夜間・早朝作業", "見積書即日発行"],
  },
];

export default function Services() {
  return (
    <section id="services" className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            OUR SERVICES
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            京都のあらゆる
            <br className="md:hidden" />
            <span className="text-primary-500 whitespace-nowrap">「片づけ」</span>
            <br className="md:hidden" />
            を、一社完結で。
          </h2>
          <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed">
            ご家庭の1点回収から、法人・不動産会社様の大型案件まで。
            京都府全域を担当エリアとし、丁寧かつスピーディーに対応します。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s) => (
            <article
              key={s.title}
              className="rounded-lg bg-background-50 border border-background-200 overflow-hidden hover:border-primary-300 transition-colors flex flex-col"
            >
              <div className="relative w-full h-52 overflow-hidden">
                <img
                  src={s.img}
                  alt={`${s.title} 京都府対応`}
                  title={`${s.title}｜${s.tag}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium">
                  {s.tag}
                </span>
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="text-xl font-bold text-foreground-950 mb-2">
                  {s.href ? (
                    <a
                      href={s.href}
                      className="hover:text-primary-600 cursor-pointer transition-colors"
                    >
                      {s.title}
                    </a>
                  ) : (
                    s.title
                  )}
                </h3>
                <p className="text-foreground-700 text-sm leading-relaxed mb-4">
                  {s.text}
                </p>
                <ul className="mt-auto grid grid-cols-2 gap-x-3 gap-y-2 pt-4 border-t border-background-200">
                  {s.items.map((it) => (
                    <li
                      key={it}
                      className="flex items-center gap-1.5 text-foreground-700 text-xs"
                    >
                      <span className="w-4 h-4 flex items-center justify-center text-primary-600">
                        <i className="ri-checkbox-circle-fill"></i>
                      </span>
                      <span>{it}</span>
                    </li>
                  ))}
                </ul>
                {s.href ? (
                  <a
                    href={s.href}
                    className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-primary-600 hover:text-primary-700 cursor-pointer transition-colors"
                  >
                    詳しく見る
                    <i className="ri-arrow-right-line"></i>
                  </a>
                ) : null}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}